import * as Yup from "yup";
import { isUSA } from "../../../utils/isUSA";
import {
  addressUsZipRegEx,
  alphanumericError,
  alphaNumericRegex,
  usZipSyntaxError,
  zipIsRequired,
} from "./constants";

export const AddressInputSchemaGenerator = ({
  testIsUSA = isUSA,
}: { testIsUSA?: (country: string | null | undefined) => boolean } = {}) =>
  Yup.object().shape({
    streetLine1: Yup.string()
      .required("Street is required")
      .matches(/\S/, "Street cannot be just spaces"),
    streetLine2: Yup.string(),
    city: Yup.string().required("City is required").matches(/\S/, "City cannot be just spaces"),
    state: Yup.string().when("country", {
      is: (country: string) => testIsUSA(country),
      then: (schema) => schema.required("State is required"),
      otherwise: (schema) => schema,
    }),
    province: Yup.string().when("country", {
      is: (country: string) => !testIsUSA(country),
      then: (schema) => schema.matches(/\S/, "State / Province cannot be just spaces"),
      otherwise: (schema) => schema,
    }),
    zip: Yup.string().when("country", {
      is: (country: string) => testIsUSA(country),
      then: (schema) =>
        schema.matches(addressUsZipRegEx, usZipSyntaxError).required(zipIsRequired),
      otherwise: (schema) => schema.matches(alphaNumericRegex, alphanumericError),
    }),
    country: Yup.string().required("Country is required"),
  });

export const AddressInputSchema = AddressInputSchemaGenerator();

export type AddressInputType = Yup.InferType<typeof AddressInputSchema>;
